import React from "react";
import "./Progress.scss";
import {illustration, techStack} from "../../portfolio";
import {Fade} from "react-reveal";
import Build from "../../assets/lottie/build";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";

export default function StackProgress() {
  if (techStack.viewSkillBars) {
    return (
      <div className={"dark-mode"} id="projects">
      <Fade bottom duration={1000} distance="20px">
        <div className="skills-container">
          <div className="skill-arms-left">

          </div>
          <div className="skill-middle">
            <span className="projects-header">Featured Projects</span>
            <div className="label-project-div">
              <span className="projects-label">That Propel Success</span>
            </div>
          </div>
          <div className="skill-arms-right">

          </div>
        </div>

        <div className="project-main-div">
          <Fade left duration={1000}>
            <a href="/project/UPay" className="project-panel-div">
              <div className="project-first-frame"></div>
              <div className="project-second-frame"></div>
              <div className="project-image-frame">
                <img
                  alt="Man Working"
                  className="test-img-project"
                  src={require("../../assets/images/upayclient.jpg")}
                ></img>
              </div>
              <div className="project-desc">
                <div className="project-hdr">Upay Digital Wallet for Clients</div>
                <div className="project-year">2024</div>
                <div className="project-lbl-div">
                  <div className="project-lbl-col">
                    <div className="project-lbl-hdr">
                      Over 40k
                    </div>
                    <div className="project-lbl-desc">
                      Increase in user base
                    </div>
                  </div>
                  <div className="project-lbl-col">
                    <div className="project-lbl-hdr">
                      120.000+
                    </div>
                    <div className="project-lbl-desc">
                      Transactions every day
                    </div>
                  </div>
                </div>
              </div>
              <div className="spotlight-project"></div>
            </a>
          </Fade>
          <Fade right duration={1000}>
            <a href="/project/SeekFake" className="project-panel-div">
              <div className="project-first-frame"></div>
              <div className="project-second-frame"></div>
              <div className="project-image-frame">
                <img
                  alt="Man Working"
                  className="test-img-project"
                  src={require("../../assets/images/seekfakemacbook.jpg")}
                ></img>
              </div>
              <div className="project-desc">
                <div className="project-hdr">SeekFake AI service to authenticate deepfakes</div>
                <div className="project-year">2025</div>
                <div className="project-lbl-div">
                  <div className="project-lbl-col">
                    <div className="project-lbl-hdr">
                      70B
                    </div>
                    <div className="project-lbl-desc">
                      Active params
                    </div>
                  </div>
                  <div className="project-lbl-col">
                    <div className="project-lbl-hdr">
                      Gemini & DeepSeek
                    </div>
                    <div className="project-lbl-desc">
                      Powered by
                    </div>
                  </div>
                </div>
              </div>
              <div className="spotlight-project"></div>
            </a>
          </Fade>
        </div>
<div className="project-main-div">
          <Fade left duration={1000}>
            <a href="/project/AlbanianCourier" className="project-panel-div">
              <div className="project-first-frame"></div>
              <div className="project-second-frame"></div>
              <div className="project-image-frame">
                <img
                  alt="Man Working"
                  className="test-img-project"
                  src={require("../../assets/images/AlbanianCourier.jpg")}
                ></img>
              </div>
              <div className="project-desc">
                <div className="project-hdr">Boosting AC Expansion across Albania and Kosovo</div>
                <div className="project-year">2021</div>
                <div className="project-lbl-div">
                  <div className="project-lbl-col">
                    <div className="project-lbl-hdr">
                      45%
                    </div>
                    <div className="project-lbl-desc">
                      Increase in postal orders
                    </div>
                  </div>
                  <div className="project-lbl-col">
                    <div className="project-lbl-hdr">
                      25%
                    </div>
                    <div className="project-lbl-desc">
                      Increase in server response time
                    </div>
                  </div>
                </div>
              </div>
              <div className="spotlight-project"></div>
            </a>
          </Fade>
          <Fade right duration={1000}>
            <a href="/project/UPayPos" className="project-panel-div">
              <div className="project-first-frame"></div>
              <div className="project-second-frame"></div>
              <div className="project-image-frame">
                <img
                  alt="Man Working"
                  className="test-img-project"
                  src={require("../../assets/images/upaypos.jpg")}
                ></img>
              </div>
              <div className="project-desc">
                <div className="project-hdr">UpayPOS for Merchant and Businesses</div>
                <div className="project-year">2022</div>
                <div className="project-lbl-div">
                  <div className="project-lbl-col">
                    <div className="project-lbl-hdr">
                      More than 200
                    </div>
                    <div className="project-lbl-desc">
                      Businesses registered
                    </div>
                  </div>
                </div>
              </div>
              <div className="spotlight-project"></div>
            </a>
          </Fade>
        </div>
      </Fade>
      </div>
    );
  }
  return null;
}
